"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelFieldTrueSize = exports.ModelMutatorTrueSize = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var collection_field_1 = require("../collection.field");
var ModelMutatorTrueSize = /** @class */ (function (_super) {
    tslib_1.__extends(ModelMutatorTrueSize, _super);
    function ModelMutatorTrueSize() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ModelMutatorTrueSize.prototype.add = function (captureId) {
        var stateValue = this.field.stateValue != null ? this.field.stateValue.slice() : [];
        if (stateValue.find(function (cId) { return captureId === cId; })) {
            return;
        }
        stateValue.push(captureId);
        this.state.setFieldValue(this.field.id, stateValue);
    };
    ModelMutatorTrueSize.prototype.copy = function (from) {
        var e_1, _a;
        try {
            for (var _b = tslib_1.__values(from.getCaptures()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var capture = _c.value;
                this.add(capture.objectId);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return true;
    };
    ModelMutatorTrueSize.prototype.clear = function () {
        var e_2, _a;
        var collection = this.field.collection;
        var usedCaptures = this.getUsedCaptures();
        try {
            for (var _b = tslib_1.__values(this.field.getCaptures()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var capture = _c.value;
                var drawableState = collection.getDrawableState(capture.objectId);
                // Don't remove markers if TS capture is used by another field
                if (drawableState != null && !usedCaptures[capture.objectId]) {
                    drawableState.clear();
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        this.state.setFieldValue(this.field.id, null);
    };
    ModelMutatorTrueSize.prototype.getUsedCaptures = function () {
        var _this = this;
        var usedCaptures = {};
        var captureIds = this.state.getFieldValue(this.field.id);
        if (captureIds == null || captureIds.length === 0) {
            return usedCaptures;
        }
        var collection = this.field.collection;
        collection.forEachField(function (currentField) {
            var e_3, _a;
            if (!CollectionModelFieldTrueSize.isTrueSizeField(currentField) || currentField.id === _this.field.id) {
                return;
            }
            var currentCaptures = currentField.getCaptures();
            try {
                for (var currentCaptures_1 = tslib_1.__values(currentCaptures), currentCaptures_1_1 = currentCaptures_1.next(); !currentCaptures_1_1.done; currentCaptures_1_1 = currentCaptures_1.next()) {
                    var currentCapture = currentCaptures_1_1.value;
                    if (captureIds.indexOf(currentCapture.objectId) !== -1) {
                        usedCaptures[currentCapture.objectId] = true;
                    }
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (currentCaptures_1_1 && !currentCaptures_1_1.done && (_a = currentCaptures_1.return)) _a.call(currentCaptures_1);
                }
                finally { if (e_3) throw e_3.error; }
            }
        });
        return usedCaptures;
    };
    return ModelMutatorTrueSize;
}(collection_field_1.ModelMutator));
exports.ModelMutatorTrueSize = ModelMutatorTrueSize;
var CollectionModelFieldTrueSize = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionModelFieldTrueSize, _super);
    function CollectionModelFieldTrueSize() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CollectionModelFieldTrueSize.isTrueSizeField = function (f) {
        return f.schema.type === CollectionModelFieldTrueSize.TYPE;
    };
    Object.defineProperty(CollectionModelFieldTrueSize.prototype, "Mutator", {
        get: function () {
            if (this._Mutator == null) {
                this._Mutator = new ModelMutatorTrueSize(this);
            }
            return this._Mutator;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelFieldTrueSize.prototype, "value", {
        get: function () {
            var e_4, _a;
            var captureIds = this.stateValue || [];
            var output = [];
            try {
                for (var captureIds_1 = tslib_1.__values(captureIds), captureIds_1_1 = captureIds_1.next(); !captureIds_1_1.done; captureIds_1_1 = captureIds_1.next()) {
                    var captureId = captureIds_1_1.value;
                    var capture = this.collection.state.getCapture(captureId);
                    if (capture == null) {
                        throw new Error("Field \"".concat(this.id, "\": Cannot find capture ").concat(captureId));
                    }
                    output.push(capture);
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (captureIds_1_1 && !captureIds_1_1.done && (_a = captureIds_1.return)) _a.call(captureIds_1);
                }
                finally { if (e_4) throw e_4.error; }
            }
            return output;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelFieldTrueSize.prototype.getOwnedCaptures = function () {
        return this.getCaptures();
    };
    CollectionModelFieldTrueSize.prototype.getCaptures = function () {
        var _this = this;
        return this.getCaptureIds()
            .map(function (c) { return _this.collection.state.getCapture(c); })
            .filter(function (c) { return !!c; }); // Handle fetchable returning "null" when race conditions occur
    };
    CollectionModelFieldTrueSize.prototype.getOwnedCaptureIds = function () {
        return this.getCaptureIds();
    };
    CollectionModelFieldTrueSize.prototype.getCaptureIds = function () {
        var stateValue = this.stateValue;
        if (stateValue == null) {
            return [];
        }
        return this.stateValue;
    };
    CollectionModelFieldTrueSize.prototype.hasValue = function () {
        return this.value.length > 0;
    };
    CollectionModelFieldTrueSize.TYPE = core_api_1.IkeFieldType.TRUE_SIZE;
    return CollectionModelFieldTrueSize;
}(collection_field_1.CollectionModelField));
exports.CollectionModelFieldTrueSize = CollectionModelFieldTrueSize;
//# sourceMappingURL=true.size.field.js.map